import { makeRequest } from '~shared/api/make-request';
import { config } from '~shared/config';

import type { FindPaymentsRequestParams } from '../model/find-payments-params';
import type { FindPaymentsResponse } from '../model/find-payments-response';

const BASE_URL = `${config.apiHost}/merchant-portal/api/v1/public/dashboard`;

export async function findPayments(
  params: FindPaymentsRequestParams
): Promise<FindPaymentsResponse> {
  const res = await makeRequest<{ payload: FindPaymentsResponse }>({
    httpMethod: 'POST',
    type: 'json',
    url: `${BASE_URL}/payments`,
    withCredentials: true,
    timeout: 60_000,
    payload: params,
  });
  return res.payload;
}

export async function generatePaymentsReport(
  params: FindPaymentsRequestParams
): Promise<{ reportId: string }> {
  const res = await makeRequest<{ payload: { reportId: string } }>({
    httpMethod: 'POST',
    type: 'json',
    url: `${BASE_URL}/run-payments-export`,
    withCredentials: true,
    timeout: 60_000,
    payload: params,
  });
  return res.payload;
}
